// More may be added later.
enum CartMessageLevelEnum {
    INFO = "INFO",
    ERROR = "ERROR",
}

export default CartMessageLevelEnum;
